import BaseSettings from "../../../core/src/ui/BaseSettings";
import Button from "../../../core/src/views/components/Button";
import SwitchButton from "../../../core/src/views/components/SwitchButton";
import SoundController from "../../../core/src/utils/SoundController";
import PointerEvents from "../../../core/src/const/PointerEvents";
import BetModel from "../../../core/src/model/BetModel";
import Layout from "../../../core/src/utils/Layout";
import SoundVars from "../../../core/src/const/SoundVars";
import { Commands } from "../../../core/src/commands/CommandEnum";
import CommandManager from "../../../core/src/commands/CommandManager";
import SceneView from "../../../core/src/views/SceneView";
import { SettingsButtons } from '../../../core/src/const/SettingsButtons';
import { VendorSettingsButtons } from '../../../src/const/VendorSettingsButtons';
import GameModel from "../../../core/src/model/GameModel";

import Locale from "../../../core/src/utils/Locale";
import Slider, { SliderOrientation } from "../../../core/src/views/components/Slider";
import SceneViewContainer from "../../../core/src/views/SceneViewContainer";
import { Container, Graphics, Point } from "pixi.js";
import App from "../../../core/src/App";
import TextField from "../../../core/src/views/components/TextField";
import ViewManager from "../../../core/src/utils/ViewManager";
import { DefaultLayers } from "../../../core/src/utils/Layers";
import { UIButtons } from "../../../core/src/ui/UIButtons";
import { VendorCommandsEnum } from "../../commands/VendorCommandsEnum";
import Layer from "../../../core/src/utils/Layer";
import GameEvents from "../../../core/src/const/GameEvents";
import VendorModel from "../../model/VendorModel";
import ButtonUtils from "../../../core/src/utils/ButtonUtils";
import Configs from "../../vendorConfigs/Configs";

export default class Settings extends BaseSettings {
    public scrollBoxLayer: Layer = ViewManager.getLayer("ScrollBox");
    public scrollBoxScene: SceneView;
    //public gameInfoPageScenes: string[];
    public gameInfoPagePositions: number[];
    public paytablePageGroups: string[];
    public paytablePagePositions: number[];
    public payTablePage: number = 1;
    public currentSettingsPage: string;
    protected pageSlider: Slider;
    protected musicSlider: Slider;
    protected soundEffectSlider: Slider;
    protected sliderContainer: SceneViewContainer;
    protected sliderContent: Container;
    private preInitializeRunning: boolean = false;
    public buttonsNames: { [key: string]: string } = {
        close: "close",
        settings: "settings",
        paytable: "paytable",
        info: "info"
    };

    protected sectionNames: { [key: string]: string } = {
        paytable: "paytable",
        gameinfo: "gameinfo"
    }

    protected sectionAction = new Map<string, ()=> void>();

    public linkNames: { [key: string]: string } = {
        responsibleGambling: "responsible_gambling"
    };

    protected pages: Map<string, () => void> = new Map();
    protected leftArrow: Button;
    protected rightArrow: Button;
    protected _minFontSizePortrait: number | string = null;
    protected _minFontSizeLandscape: number | string = null;
    protected hasRestrictions: Map<string, () => boolean> = new Map();
    protected musicToggle: SwitchButton;
    protected soundToggle: SwitchButton;
    private globalY = 0;
    protected masterSndOverlay: Graphics;
    protected settingsPageRestrictions;


    get minFontSize(): number | string {
        if (Layout.isLandscape()) {
            return this.minFontSizeLandscape
        } else {
            return this.minFontSizePortrait
        }
    }

    get minFontSizePortrait(): number | string {
        return this._minFontSizePortrait
    }
    set minFontSizePortrait(value: number | string) {
        this._minFontSizePortrait = value
    }
    get minFontSizeLandscape(): number | string {
        return this._minFontSizeLandscape
    }
    set minFontSizeLandscape(value: number | string) {
        this._minFontSizeLandscape = value
    }

    constructor() {
        super();


        this.hasRestrictions.set("autoplay", () => Configs.game.clientConfig.autoplayDisable);
        this.hasRestrictions.set("autoplay2", () => Configs.game.clientConfig.autoplayDisable);
        this.hasRestrictions.set("autoplay3", () => Configs.game.clientConfig.autoplayDisable);
        this.hasRestrictions.set("history", () => Configs.game.clientConfig.disableShowHistory);
        this.hasRestrictions.set("buyFeature", () => Configs.game.clientConfig.disableBuyFeature);

        this.addSpecificPageRestrictions();

        this.masterSndOverlay = ViewManager.getLayer("MasterSoundArea").setScene().shapes.get("snd");

        this.masterSndOverlay.on(PointerEvents.DOWN, () => {
            CommandManager.execute(Commands.TOGGLE_MASTER_SOUND);
            CommandManager.execute(VendorCommandsEnum.TOGGLE_SOUND_BUTTON, "uiSoundBtn");
            SoundController.playSound(SoundVars.BUTTON_CLICK);
        });

        this.sectionAction.set("paytable", () => this.showPayTable());
        this.sectionAction.set("gameinfo", () => this.showGameInfo());

        this.navigationActions.set(this.buttonsNames.close, () => {
            this.hide();
        });
        this.navigationActions.set(VendorSettingsButtons.PAYTABLE, () => {
            this.showPayTable();
            SoundController.playSound(SoundVars.BUTTON_CLICK);
        });

        this.navigationActions.set(VendorSettingsButtons.SETTINGS, () => {
            this.showGameSettings();
            SoundController.playSound(SoundVars.BUTTON_CLICK);
        });
        this.navigationActions.set(VendorSettingsButtons.INFO, () => {
            this.showGameInfo();
            SoundController.playSound(SoundVars.BUTTON_CLICK);
        });
        this.navigationActions.set(VendorSettingsButtons.HOME, () => {
            CommandManager.execute(Commands.GO_HOME);
            SoundController.playSound(SoundVars.BUTTON_CLICK);
        });

        // remove when settings are done
        this.defaultPage = "paytable";
        /*window.addEventListener("orientationchange", function() {
            if (!this.isHidden && !this.preInitializeRunning) {
                const page = this.currentSettingsPage;
                CommandManager.execute(Commands.CLOSE_SETTINGS);
                UIUtils.showMessageBox(Locale.getString(LocaleId.ui_settings_closed_text), Locale.getString(LocaleId.ui_settings_closed_title))
                    .then(() => {
                        CommandManager.execute(VendorCommandsEnum.GAME_PAUSED, false);
                    });
                // this.show(page);
            }
        }.bind(this));*/
    }

    protected addSpecificPageRestrictions() {
        if (Configs.settings.pagesToHide) {
            Configs.settings.pagesToHide.forEach((restriction) => {
                restriction.keys.forEach(page => {
                    this.hasRestrictions.set( page, () => restriction.enabled() )
                });
            })
        }
    }

    public preInitialize(initial: boolean) {
        // need to be implemented to work correct - troll
        if (initial) {
            this.show(this.defaultPage);
            // In order to update the sliderbox properly, we must emit the resize event.
            App.dispatcher.emit(GameEvents.RESIZE, false);
            this.preInitializeRunning = true;
            this.contentLayer.interactive = false;
            this.interfaceLayer.interactive = false;
            this.backgroundLayer.interactive = false;
            this.contentLayer.visible = false;
            this.interfaceLayer.visible = false;
            this.backgroundLayer.visible = false;
            this.scrollBoxLayer.visible = false;
            const settingsButton = ViewManager.getLayer(DefaultLayers.BetBar).setScene().buttons.get(UIButtons.Settings);
            const lastButtonState = settingsButton.state;

            const delay = 50;
            for (let i = 0; i < this.paytablePageGroups.length; i++) {
                setTimeout(() => {
                    this.switchPayTables("next", this.paytablePageGroups.length);
                    settingsButton.setEnabled(false);
                }, delay * i);
            }
            setTimeout(() => {
                this.hide();
                this.contentLayer.visible = true;
                this.interfaceLayer.visible = true;
                this.backgroundLayer.visible = true;
                this.scrollBoxLayer.visible = true;
                settingsButton.setEnabled(lastButtonState != "DISABLED");
                this.preInitializeRunning = false;
            }, this.paytablePageGroups.length * delay)
        } else {
            // TODO: Implement the logic, when mobile device has been rotated for 1st time.
        }
    }

    public show(arg: string) {

        this.globalY = 0;

        if(this.sectionNames[arg]) {
            this.defaultPage = arg;
        }

        if (this.preInitializeRunning) {
            return;
        }

        this.masterSndOverlay.interactive = true;

        CommandManager.execute(VendorCommandsEnum.GAME_PAUSED, true);
       // this.calculateMinFontSize();
        super.show();

        this.scrollBoxLayer.setScene("open");
        this.scrollBoxScene = this.scrollBoxLayer.getCurrentScene();
        this.scrollBoxScene.visible = false;
        this.buttons = [];
        this.interfaceScene.buttons.forEach((btn) => {
            if (btn != this.interfaceScene.buttons.get(SettingsButtons.CLOSE)) {
                this.buttons.push(btn);
            }
        });
        if (!GameModel.isMobile() && GameModel.urlParams.hidehome) {
            this.interfaceScene.buttons.get(SettingsButtons.HOME).visible = false;
        }
        if(Configs.game.clientConfig?.hideGameRules) {
            this.interfaceScene.buttons.get(SettingsButtons.INFO).visible = false;
        }


        if(this.sectionAction.has(this.defaultPage)) {
            this.sectionAction.get(this.defaultPage)();
        } else {
            this.showPayTable();
        }

    }

    public hide() {
        this.masterSndOverlay.interactive = false;
        this.currentSettingsPage = "";
        this.scrollBoxScene.visible = false;
        if(!this.preInitializeRunning) {
            SoundController.playSound(SoundVars.BUTTON_CLICK);
        }
        CommandManager.execute(VendorCommandsEnum.GAME_PAUSED, false);
        super.hide();
    }

    protected showGameInfo() {
        if (this.currentSettingsPage == "gameinfo") {
            return;
        }

        this.globalY = 0;

        this.initializaSlider();

        this.interfaceScene.orientationChangeCallback = ()=>{
            this.pageSlider.setBounds();
        }
        this.pageSlider.resetSlderPosition();

        this.currentSettingsPage = "gameinfo";
        this.payTablePage = 0;  // need to rename on pageCounter

        this.gameInfoPagePositions = [];

        this.scene.preOrientationChangeCallback = () => {

            this.hide();

            // while(this.sliderContent.children.length) {
            //     let child = this.sliderContent.children[0];
            //     this.sliderContent.removeChild(child);
            //     //child.destroy();
            // }
        }

        this.scene.orientationChangeCallback = () => {

            this.show("gameinfo");

            // this.sliderContent.scale.x = this.sliderContent.scale.y = 1/(this.sliderContainer.scale.x*this.sliderContainer.parent.scale.x);
            // this.createGIScenes();
            // this.pageSlider.setValue(this.gameInfoPagePositions[this.payTablePage]/(this.sliderContent.height - (this.sliderContainer.mask as any).height )*100);
            // this.sliderContent.y = -(this.sliderContent.height - (this.sliderContainer.mask as any).height)*Number(this.pageSlider.getValue())/100;

            // this.updateTitle();
        }

        // this.sliderContent.scale.x = this.sliderContent.scale.y = 1/(this.sliderContainer.scale.x*this.sliderContainer.parent.scale.x);
        this.createGIScenes();


        this.updateTitle();
        this.update();
    }

    createGIScenes() {

        this.gameInfoPagePositions = [];

        let content = this.contentLayer.getOrphanedScene(
            "gameinfo"//this.gameInfoPageScenes[0]
        );
        content.x = 0;
        content.y = 0;

        this.fillTexts(content);
        content.groups.forEach(group => {
           if(!this.sceneHasRestriction(group)) {
                group.y = this.globalY;
                group.x = 0;
                const scale = this.scrollBoxScene.shapes.get("slider").scale.x;
                group.scale.set(scale, scale);
                this.globalY += group.height + 10;

                this.sliderContent.addChild(group);
                this.gameInfoPagePositions.push(group.y);
           }
        });

        this.setButtonsBehaviours(content);

        // this.pageSlider.setupContentSlideSpeed(((this.sliderContainer.mask as any).height/ this.sliderContent.height));
    }

    protected initializaSlider() {

        if(this.pageSlider) {

            while(this.sliderContent.children.length) {
                let child = this.sliderContent.children[0];
                this.sliderContent.removeChild(child);
               // debugger;
               // child.destroy();
            }
            this.pageSlider.off(PointerEvents.UPDATE);
            this.pageSlider.destroy();
            this.pageSlider = null;
        }

        const sliderElements = {
            handle:this.scrollBoxScene.buttons.get(
                "info_slider_handle"
            ),
            upBtn:this.scrollBoxScene.buttons.get(
                "up"
            ),
            downBtn:this.scrollBoxScene.buttons.get(
                "down"
            ),
            track:this.scrollBoxScene.sceneSprites.get("info_slider_track"),
            hitArea:this.scrollBoxScene.shapes.get("slider"),
        }

        this.pageSlider = new Slider(sliderElements,SliderOrientation.Vertical, false, null, "menu")

        this.buttons = [];

        this.sliderContent = new Container();
        this.scene = this.contentLayer.setScene("slider");
        this.sliderContainer = this.scene.containers.get("slider");
        this.sliderContainer.addChild(this.sliderContent);

        this.pageSlider.on(PointerEvents.UPDATE,()=>{
            this.sliderContent.y = -(this.sliderContent.height - (this.sliderContainer.mask as any).height)*Number(this.pageSlider.getValue())/100;
        });
    }

    protected showPayTable(page?: string) {
        if (this.currentSettingsPage === "paytable") {
            return;
        }

        this.globalY = 0;

        this.initializaSlider();

        this.interfaceScene.orientationChangeCallback = ()=>{
            this.pageSlider.setBounds();
        }
        this.pageSlider.resetSlderPosition();

        this.currentSettingsPage = "paytable";
        this.payTablePage = 0;
        this.paytablePageGroups = []; // all paytable groups
        this.paytablePagePositions = [];

        this.scene.preOrientationChangeCallback = () => {

            this.hide();

            // while(this.sliderContent.children.length) {
            //     let child = this.sliderContent.children[0];
            //     this.sliderContent.removeChild(child);
            //     //child.destroy();
            // }
        }

        this.scene.orientationChangeCallback = () => {

            this.show("paytable");

            // this.sliderContent.scale.x = this.sliderContent.scale.y = 1/(this.sliderContainer.scale.x*this.sliderContainer.parent.scale.x);
            // this.createPtScenes();
            // this.pageSlider.setValue(this.paytablePagePositions[this.payTablePage]/(this.sliderContent.height - (this.sliderContainer.mask as any).height )*100);
            // this.sliderContent.y = -(this.sliderContent.height - (this.sliderContainer.mask as any).height)*Number(this.pageSlider.getValue())/100;

            // this.updateTitle();
        }
        // this.sliderContent.scale.x = this.sliderContent.scale.y = 1/(this.sliderContainer.scale.x*this.sliderContainer.parent.scale.x);

        this.createPtScenes();

        this.updateTitle();
        // this.scene.onOrientationChange();
        this.update();
    }

    createPtScenes() {

        this.paytablePagePositions = [];

        let content = this.contentLayer.getOrphanedScene(
           "paytable"//this.paytablePageGroups[0]
        );
        content.x = 0;
        content.y = 0;///this.sliderContent.height/this.sliderContent.scale.x;

        this.fillTexts(content);
        content.groups.forEach(group => {
            if(!this.sceneHasRestriction(group)) {
                group.y = this.globalY;
                group.x = 0;
                const scale = this.scrollBoxScene.shapes.get("slider").scale.x;
                group.scale.set(scale, scale);
                this.globalY += group.height + 10;
                this.sliderContent.addChild(group);
            }
        });

        this.calculateWins(content);

        // this.pageSlider.setupContentSlideSpeed(((this.sliderContainer.mask as any).height/ this.sliderContent.height));
    }

    update() {

        switch (this.currentSettingsPage) {
            case VendorSettingsButtons.SETTINGS:
                this.scrollBoxScene.visible = false;
                break;
            case VendorSettingsButtons.PAYTABLE:
                this.scrollBoxScene.visible = true;
                break;
            case VendorSettingsButtons.GAME_INFO:
                this.scrollBoxScene.visible = true;
                break;
            default:
                break;
        }

        if(this.musicToggle && this.soundToggle) {
            this.musicToggle.switch(SoundController.isMusicEnabled);
            this.soundToggle.switch(SoundController.isEffectsEnabled);
        }

    }

    protected rearangeSettingsPageButtons() {
        // array with all buttons and labels positions by rows
        let freePositions = [];
        let rowBtnsCounter: number = 0;
        // on which row to place next button and label
        let freeBtnsRow: number = 0;

        this.scene.buttons?.forEach((btn, name) => {
            let label = this.scene.sceneTextFields.get("ui_"+name);

            freePositions[rowBtnsCounter] = {
                "button":[btn.butImg.x, btn.butImg.y],
                "label":[label.children[0].position.x, label.children[0].position.y]
            };

            if ( this.settingsPageRestrictions.has(name) &&
                this.settingsPageRestrictions.get(name)())
            {
                btn.setVisible(false);
                label.visible = false;
            } else {
                btn.butImg.transform.position.x = freePositions[freeBtnsRow].button[0];
                btn.butImg.transform.position.y = freePositions[freeBtnsRow].button[1];

                label.children[0].position.x = freePositions[freeBtnsRow].label[0];
                label.children[0].position.y = freePositions[freeBtnsRow].label[1];
                freeBtnsRow++;
            }
            rowBtnsCounter++;
        });
    }

    protected showGameSettings() {

        const saveSettings = () => {
            CommandManager.execute(Commands.SAVE_SETTINGS);
        };

        if (this.currentSettingsPage == VendorSettingsButtons.SETTINGS) {
            return;
        }

        this.currentSettingsPage = "settings";
        this.scene = this.contentLayer.setScene("settings", null, true);

        this.scene.orientationChangeCallback = () => {
            this.rearangeSettingsPageButtons();
            if (this.scene.sceneTextFields) {
                ButtonUtils.fontSizeUnificationText(this.scene.sceneTextFields);
            }
        }
        //if(!this.musicToggle && !this.soundToggle) {
            this.musicToggle = this.scene.buttons.get(SettingsButtons.MUSIC) as SwitchButton;
            this.soundToggle = this.scene.buttons.get(SettingsButtons.SOUND) as SwitchButton;
        //}
        this.musicToggle.switch(SoundController.isMusicEnabled);
        this.soundToggle.switch(SoundController.isEffectsEnabled);
        let skipIntroToggle = this.scene.buttons.get(VendorSettingsButtons.SKIP_INTRO) as SwitchButton;
        skipIntroToggle.switch(VendorModel.allowSkipIntro);
        let fastPlayToggle = this.scene.buttons.get(VendorSettingsButtons.FAST_PLAY) as SwitchButton;
        fastPlayToggle.switch(GameModel.turboSpin);
        let spaceToSpinToggle = this.scene.buttons.get(VendorSettingsButtons.SPACE_TO_SPIN) as SwitchButton;
        spaceToSpinToggle.switch(GameModel.spaceToSpin);
        let swipeToSpinToggle = this.scene.buttons.get(VendorSettingsButtons.SWIP_REELS) as SwitchButton;
        swipeToSpinToggle.switch(VendorModel.allowSwipeSpin);

        if (!this.scene.isReused) {

            this.settingsPageRestrictions = new Map([
                ["skip_intro", ()=> Configs.game.clientConfig.skipIntroVideo],
                ["fast_play", ()=> !Configs.game.clientConfig.quickStop],
                ["swip_reels", ()=> true],
                ["space_to_spin", ()=> GameModel.isMobile()]
            ]);

            this.soundToggle.on(PointerEvents.DOWN, () => {
                this.soundToggle.toggle();
                CommandManager.execute(Commands.TOGGLE_SOUND_FX, this.soundToggle.isSelected());
                CommandManager.execute(VendorCommandsEnum.TOGGLE_SOUND_BUTTON);
                saveSettings();
                SoundController.playSound(SoundVars.BUTTON_CLICK);
            });

            this.musicToggle.on(PointerEvents.DOWN, () => {
                SoundController.playSound(SoundVars.BUTTON_CLICK);
                this.musicToggle.toggle();
                CommandManager.execute(Commands.TOGGLE_MUSIC, this.musicToggle.isSelected());
                CommandManager.execute(VendorCommandsEnum.TOGGLE_SOUND_BUTTON);
                saveSettings();
            });

            skipIntroToggle.on(PointerEvents.DOWN, () => {
                SoundController.playSound(SoundVars.BUTTON_CLICK);
                skipIntroToggle.toggle();
                CommandManager.execute(VendorCommandsEnum.TOGGLE_SKIP_INTRO);
                saveSettings();
            });

            swipeToSpinToggle.on(PointerEvents.DOWN, () => {
                swipeToSpinToggle.toggle();
                CommandManager.execute(VendorCommandsEnum.TOGGLE_SWIPE_TO_SPIN);
                saveSettings();
            });

            spaceToSpinToggle.on(PointerEvents.DOWN, () => {
                spaceToSpinToggle.toggle();
                CommandManager.execute(Commands.TOGGLE_SPACE_TO_SPIN);
                saveSettings();
            });

            fastPlayToggle.on(PointerEvents.DOWN, () => {
                // SoundController.playSound(SoundVars.BUTTON_CLICK);
                fastPlayToggle.toggle();
                // GameModel._turboSpin = !GameModel._turboSpin;
                CommandManager.execute(Commands.TOGGLE_TURBO_SPIN);
                saveSettings();
            });
        }

        this.rearangeSettingsPageButtons();
        this.update();
        this.updateTitle();
        ButtonUtils.fontSizeUnificationText(this.scene.sceneTextFields);
    }

    protected sceneHasRestriction(group: Container): boolean {
        let result: boolean = false;

        if(this.hasRestrictions.has(group.name)) {
            result = this.hasRestrictions.get(group.name)();
        }

        return result;
    }

    protected switchPayTables(direction: string, pagesCount: number) {

        this.pageSlider.setValue(this.paytablePagePositions[this.payTablePage]/(this.sliderContent.height - (this.sliderContainer.mask as any).height )*100);
    }

    updateTitle() {
        let  pageNames = ViewManager.getLayer(DefaultLayers.MenuUI).setScene("open");
        let pgNamesMap = new Map([
            ["paytable", "ui_paytable"],
            ["settings", "ui_settings"],
            ["gameinfo", "ui_game_rules"],
        ])
        pageNames.sceneTextFields.forEach((el, name) => {
            if(name == pgNamesMap.get(this.currentSettingsPage)) {
                el.visible = true;
            } else {
                el.visible = false;
            }
        })
    }

    private calculateWins(scene: SceneView) {
        if (scene.sceneMoneyFields) {
            GameModel.serverGameConfig?.paytable.forEach(({ symbol, pay, n }) => {
                let key = "pt_sym_" + symbol + "_" + n;
                if (scene.sceneMoneyFields.has(key)) {
                    scene.sceneMoneyFields.get(key).centerVertical();
                    scene.sceneMoneyFields.get(key).value =
                        (BetModel.totalBet / BetModel.betDivisor) * pay;
                }
            });
        }
    }

    protected setButtonsBehaviours(scene: SceneView = this.scene) {
        if(scene.buttons) {
            if(scene.buttons.has("history")) {
                const historyBtn = scene.buttons.get("history");
                historyBtn.once(PointerEvents.DOWN, (e) => {
                    historyBtn.off(PointerEvents.DOWN);
                    CommandManager.execute(Commands.REQUEST_HISTORY);
                   // e.stopPropagation();
                });
            }
        }
    }

    private fillTexts(scene: SceneView = this.scene) {

        if(!scene) {
            return;
        }

        const textsToHide = Configs.settings.textsToHide;

        let textFieldName = null;
        let body = "";
        let result: {textFieldName: string | null, body: string}[] = [];

        if (scene.sceneTextFields) {
            scene.sceneTextFields.forEach((txtField, name) => {
                body = this.getBodyString(name, textsToHide);
                textFieldName = name;
                result.push({
                    textFieldName,
                    body
                })
            });
        }

        result.forEach(({textFieldName, body}) => {

            if (textFieldName && body.length > 0) {
                this.setFixedFontSize(scene, textFieldName)
                this.setText(scene, textFieldName, body)
            }
        })

    }

    /*protected applyMinFontSize(textField: TextField): void {
        textField.style.fontSize = this.minFontSize;
        textField.fixFontSize = this.minFontSize;
    }*/

    protected setFixedFontSize(scene: SceneView, textFieldName: string): void {
        let textField = scene.sceneTextFields.get(textFieldName) as TextField;
        let fSize = (textField.initStyle.fontSize < this.minFontSize)
            ? this.minFontSize
            : textField.initStyle.fontSize
        textField.style.fontSize = fSize;
        textField.fixFontSize = fSize;
    }

    protected setText(scene: SceneView = this.scene, textFieldName: string, body: string): void {
        let textField = scene.sceneTextFields.get(textFieldName) as TextField;
        //textField.y = this.globalY;
        textField.text = body;
    }

    protected getBodyString = (key: string, textsToHide:{ enabled: Function; keys: string[]}[]) => {
        let body = "";
        let index = 1;
        let element = key;
        // if(!Locale.getString(element).match("troll")) {
        //     body += "" + Locale.getString(element);
        // } else {
            element = `${key}_${index}`;
            let hideIt: boolean = false;

            while (!Locale.getString(element).match("[|]")) {
                if(textsToHide && textsToHide.length) {

                    textsToHide.forEach((textToHide) => {  // all restriction
                        if(textToHide.enabled()) {  // have valid restriction
                            if(textToHide.keys.indexOf(element) != -1) {
                                hideIt = true;
                            }
                        }
                    })
                }

                if(!hideIt) {
                    body += "" + Locale.getString(element) + "\n";
                }
                hideIt = false;
                index++;
                element = `${key}_${index}`;
            }
       // }

        return body
    }

/*
    textsToHide.forEach((textToHide) => {
        if(!textToHide.enabled) {
            return;
        }
        textToHide.lines.forEach((line) => {

        });
    });
*/

    protected toggleSound() {
        //
    }

}
